/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import { useMutation, useQuery } from '@apollo/client';

import { TimerToReview } from '../../../components/FormContents/components/TimerToReview/TimerToReview';
import Form from '../../../components/FormContents';
import {
  EDIT_CONTENT_BY_WRITER_ID,
  ADD_CONTENT_BY_WRITER_ID,
} from '../../../queries/contentWriter';
import {
  GET_TITLE_CONTENT_BY_ID,
  GET_CONTENT_HISTORY,
} from '../../../queries/titleContent';

const History = (titleId) => {
  const res = useQuery(GET_CONTENT_HISTORY, {
    variables: { titleId },
    fetchPolicy: 'network-only',
  });
  return res;
};

const TitleContent = (titleId, isStartRevision) => {
  const res = useQuery(GET_TITLE_CONTENT_BY_ID, {
    variables: { id: titleId, inReview: isStartRevision },
    fetchPolicy: 'network-only',
  });
  return res;
};

export default function Update({
  titleId,
  setShowDrawer,
  isStartRevision,
  refetchContentList,
}) {
  const { data, loading, error, refetch } = TitleContent(
    titleId,
    isStartRevision,
  );

  const { data: historiesData, historiesloading } = History(titleId);

  const [createContent] = useMutation(ADD_CONTENT_BY_WRITER_ID, {
    update: async () => {
      await refetch();
    },
  });
  const [updateContent] = useMutation(EDIT_CONTENT_BY_WRITER_ID);

  if (loading || historiesloading) return <>Loading...</>;
  if (error) return <>{`Error! ${error.message}`}</>;

  if (data.titleContent.titles[0] && data.titleContent.titles[0].contentId) {
    return (
      <Form
        updateContentMutation={updateContent}
        data={data.titleContent.titles[0]}
        setShowDrawer={setShowDrawer}
        permissions={data.titleContent.permissions}
        dynamicFields={data.titleContent.dynamicFields}
        refetchContent={refetchContentList}
        isStartRevision={isStartRevision}
        TimerToReview={
          <TimerToReview
            totalTimeToReviewInSec={
              historiesData?.contentHistories?.totalTimeToReviewInSec || 0
            }
          />
        }
      />
    );
  }

  return (
    <Form
      updateContentMutation={createContent}
      data={data.titleContent.titles[0]}
      setShowDrawer={setShowDrawer}
      permissions={data.titleContent.permissions}
      dynamicFields={data.titleContent.dynamicFields}
      refetchContent={refetchContentList}
    />
  );
}
